import React from "react"
import { Form as AntForm } from "antd"
import PropTypes from "prop-types"

import Drawer from "@components/Page/Drawer"
import { Form } from "@components/Form"

import api from "@api"
import { MODAL_WIDTH2 } from "@components/constants"
import { useAppContext } from "@components/AppContext"
import { TransactionShape } from "@shapes"

import getUpdateInputs from "./helpers/getUpdateInputs"

const updateOperation = api.get("transactions/UpdateRejectedTransactionAmount")

const LABEL_TITLE = "Edit Transaction"
const LABEL_UPDATE = "Save"


const TransactionUpdateDrawer = ({ drawer, onSuccess, transaction }) => {
  const [ form ] = AntForm.useForm()

  const { request } = useAppContext()

  const inputs = getUpdateInputs()
  const schema = updateOperation.getSchema(inputs)

  const onAfterSubmit = async (updatedTransaction) => {
    await onSuccess(updatedTransaction)

    drawer.current.close()
  }

  const drawerProps = {
    title: LABEL_TITLE,
    width: MODAL_WIDTH2,
    drawer,
  }

  const formProps = {
    item: transaction,
    onSuccess: onAfterSubmit,
    operation: updateOperation.id,
    submitLabel: LABEL_UPDATE,
    form,
    schema,
    request,
  }

  return (
    <Drawer {...drawerProps}>
      <Form {...formProps} />
    </Drawer>
  )
}

TransactionUpdateDrawer.propTypes = {
  drawer: PropTypes.shape({}).isRequired,
  onSuccess: PropTypes.func.isRequired,
  transaction: TransactionShape.isRequired,
}

export default TransactionUpdateDrawer
